<template>
  <span>
    <span
      v-if="element.type == 'text'"
      :class="element.class"
      class="me-1"
      style="word-break: break-word"
    >
      {{ $bct(element.text) }}
    </span>
    <span v-if="element.type == 'link'">
      <a
        :class="element.class"
        :href="element.href"
        class="me-1"
        style="word-break: break-word"
        target="_blank"
      >
        {{ $bct(element.text) }}
      </a>
    </span>
    <br v-if="element.type == 'break'" />
  </span>
</template>

<script setup>
const $bct = inject('translator');

defineProps({
  element: {
    type: Object,
    default: () => null,
  },
});
</script>
